import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bashboard_user_company",
  "use": "icon-bashboard_user_company-usage",
  "viewBox": "0 0 28 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 28 24\" id=\"icon-bashboard_user_company\">\n<path d=\"M2.7,21.8v-1.5h1.5v-15c0-1.7,1.3-3,3-3h7.5c1.7,0,3,1.3,3,3v4.5h3c1.7,0,3,1.3,3,3v7.5h1.5v1.5H2.7z M16.3,5.2\n\tc0-0.8-0.7-1.5-1.5-1.5H7.2c-0.8,0-1.5,0.7-1.5,1.5v15h10.5V5.2z M22.3,12.8c0-0.8-0.7-1.5-1.5-1.5h-3v9h4.5V12.8z M7.2,12.8h6v1.5\n\th-6V12.8z M7.2,9.7h6v1.5h-6V9.7z M7.2,6.7h6v1.5h-6V6.7z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol